import type { ReactNode } from 'react'

import type { MobileCardItem } from '@/core/types/cardNavigation.type'
import { createAccordion } from '@/core/utils/createAccordion'
import type { GraftabilityIssue } from '@/core/utils/graftability'

interface CreateNavigationCardItemParams {
  id: string
  title: ReactNode
  name: string
  badge?: string
  description?: string
  content: ReactNode
  isOpen: boolean
  onAccordionToggle: (itemId: string) => void
  graftabilityIssues?: GraftabilityIssue[]
}

export const createNavigationCardItem = ({
  id,
  title,
  name,
  badge,
  description,
  content,
  isOpen,
  onAccordionToggle,
  graftabilityIssues,
}: CreateNavigationCardItemParams) => {
  const mobileCard: MobileCardItem = {
    id,
    name,
    badge,
    description,
    content,
    graftabilityIssues,
  }

  const detail = createAccordion(id, title, content, isOpen, onAccordionToggle, badge)

  return { mobileCard, detail }
}
